import Auth from "./Auth/Reducer";
import General from "./General/Reducer";
import Filter from "../Components/Commons/Topbar/Filter/Reducer";

export default {
    Auth,
    General,
    Filter
}